// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type EditorTextBoldIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from editor-text-bold.svg
 */
export default function EditorTextBoldIcon(props: EditorTextBoldIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="EditorTextBoldIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8.661 16q1.207 0 2.193-.351a5 5 0 0 0 1.69-.993q.706-.642 1.081-1.557t.375-2.03q0-.435-.114-.893a4 4 0 0 0-.325-.87 4 4 0 0 0-.495-.754 4.4 4.4 0 0 0-.604-.597q-.255-.19 0-.412.572-.503.953-1.311.382-.81.382-1.568 0-.96-.395-1.813a4.6 4.6 0 0 0-1.08-1.484q-.687-.63-1.627-.999A5.5 5.5 0 0 0 8.66 0h-6.14a.53.53 0 0 0-.362.14A.42.42 0 0 0 2 .456v15.086q0 .178.159.318.16.139.362.139zm-.127-9.852H5.826q-.255 0-.254-.223V3.437q0-.235.254-.235h2.708q.673 0 1.195.435.52.435.521 1.027 0 .591-.521 1.038a1.78 1.78 0 0 1-1.195.446m-2.708 6.65h2.708q.84 0 1.335-.525.495-.524.495-1.205 0-.658-.495-1.188-.496-.53-1.335-.53H5.826q-.255 0-.254.234v2.99q0 .224.254.224"
        />
      </g>
    </svg>
  );
}
